import { render, staticRenderFns } from "./IncidentSettings.vue?vue&type=template&id=04d9a748&"
import script from "./IncidentSettings.vue?vue&type=script&lang=js&"
export * from "./IncidentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports